import { BasePluginData } from './base-plugin-data';

/**
 * Represents cloud provider configuration data for a resource
 */
export class CloudProviderData extends BasePluginData {
  override get pluginStepName(): string { return 'CloudProviderData'; }

  /**
   * Cloud service provider name (e.g., "AWS", "Azure", "GCP")
   */
  provider: string = '';

  /**
   * Geographical region for the cloud resource
   * Region codes are specific to each provider (e.g., "us-east-1" for AWS, "eastus" for Azure)
   */
  region: string = '';

  /**
   * Instance size/type for the cloud resource
   * Size identifiers are specific to each provider (e.g., "t2.micro" for AWS,
   * "Standard_B1s" for Azure, or "e2-micro" for GCP)
   */
  size: string = '';

  /**
   * Is the data storage for the cloud resource.
   * In case of Azure: Standard_LRS, etc.
   * In case of AWS: s3, etc.
   * In case of GCP: STANDARD, etc.
   */
  storage: string = '';
}
